<template>
    <div class="page-wrapper">
        <TopBarDetail
            :title="lbl.reward.page_title"
            type="list"
            @clickBack="clickBack()" />
        <div id="reward_content" class="page-content">
            <CategorySlider
                :locale="localeCode"
                :categoryConfig="categoryConfig"
                :busEvent="busCategory"
                :tracking="tracking"
                @changeCategory="changeCategory($event)" />
            <div class="wrapper-campaign">
                <CampaignList
                    :lbl="lbl.campaign"
                    :isLoading='isLoading'
                    :initListConfig="listConfig"
                    :initFilterConfig="filterConfig"
                    :busEvent="busCampaign"
                    :tracking="tracking"
                    :trackingEvent="'reward'"
                    @toggleLoading="toggleLoading($event)" />
            </div>
        </div>
        <ModalMaster :controller="modalController" />
    </div>
</template>

<script>
import Vue from "vue";
import CacheHelper from "@/helper/CacheHelper.js";
import { TrackingService } from "@/helper/TrackingHelper.js";
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ModalMixin from '@/mixin/ModalMixin.js';
// component
import CampaignList from "../component/CampaignList.vue";
import TopBarDetail from '@/components/Layout/TopBarPage/TopBarDetail.vue';
import CategorySlider from '../component/CategorySlider.vue';
// core
import {
  CampaignListConfigBuilder,
  CampaignListFilterConfigBuilder
} from "@/core/Campaign/model/CampaignConfigModel.js";
import ConfigManager from "@/config/ConfigManager.js";
import { CategoryConfigBuilder } from "@/core/Campaign/model/CategoryConfigModel.js";

export default {
    name: "Reward",
    mixins: [AccountMixin, LocaleMixin, ModalMixin],
    components: {
        // TopBar,
        CampaignList,
        TopBarDetail,
        CategorySlider,
    },
    data: function() {
        return {
            isLoading: false,
            isLoaded: false,
            arrCampaign: [],
            dashboardConfig: ConfigManager.getDashboardConfig().mainDashboard,
            listConfig: {},
            filterConfig: {},
            busCampaign: new Vue(),
            busModal: new Vue(),

            categoryConfig: {},
            busCategory: new Vue(),
            tracking: new TrackingService(this)
        };
    },
    created: function() {
        let category = null;
        let catId = this.$route.params.catId;
        if (catId) {
            category = {
                id:catId
            }
        } 
        this.initialCategory(category);
        this.initialConfig(category);
        this.tracking.screenName('Reward_Page');
        //console.log(this.lbl.campaign)
    },
    methods: {
        //event
        clickBack: function () {
            var cache = new CacheHelper('session');
            if(cache.getCache('isFromBDMList')){
                cache.removeCache('isFromBDMList');
                this.$router.push('/');
            }else if(cache.getCache('isFromSuccess')){
                cache.removeCache('isFromSuccess');
                this.$router.push('/');
            }else{
                this.$router.back();
            }

        },
        changeCategory: function (category) {
            this.isLoaded = true;
            this.initialConfig(category);
        },
        //initial
        initialCategory: function (category) {
            var categoryConfig = new CategoryConfigBuilder()
                .setConfig(ConfigManager.getCategoryConfig().menuCategory)
                .setLocale(this.localeCode);

            if(category){
                categoryConfig.setCatId(category.id);
            }
            this.categoryConfig = categoryConfig.create();
        },
        initialConfig: function(category) {
            var configStr = ConfigManager.getCampaignListDevApp();
            var listConfig = new CampaignListConfigBuilder()
                .setConfigList(configStr)

            if(category){
                listConfig.setCatId(category.id);
            }

            this.listConfig = listConfig.create();

            var filterConfig = new CampaignListFilterConfigBuilder().create();
            this.filterConfig = filterConfig;

            if(category){
                this.busCampaign.$emit("reInitList",{listConfig: this.listConfig, filterConfig: this.filterConfig});
            }
        },
        //utilities
        showLoading: function() {
            setTimeout(() => {
                this.loadingModal.show();
            },0)
        },
        hideLoading: function() {
            setTimeout(() => {
                this.loadingModal.hide();
            },300)
        },
        toggleLoading: function (isLoading) {
            this.isLoading = isLoading;
            if(this.isLoading){
                this.showLoading();
            }else{
                this.hideLoading();
            }
        },
    }
};
</script>
<style lang='scss' scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseDisplay.scss";

#reward_content {
    background-color: $deep-blue;
    padding: {
        top: $topbar-height;
    };
}

.wrapper-campaign {
    padding: 24px 22px 24px;
}
</style>
